<nb-card status="info">
  <nb-card-header>
    <ngx-view-document [content]="quiz.question"> </ngx-view-document>
  </nb-card-header>

  <nb-card-body
    *ngIf="quiz.type !== 'input'"
    [nbSpinner]="loadingContentEditor"
    nbSpinnerStatus="info"
  >
    <h6 *ngIf="quiz.type === 'radio'">Chọn 1 đáp án đúng</h6>
    <h6 *ngIf="quiz.type === 'check'">Chọn 1 hoặc nhiều đáp án đúng</h6>

    <div class="row">
      <div
        [ngClass]="
          isMobile ? 'col-12' : 'col-' + (12 / quiz.answers.length).toFixed(0)
        "
        *ngFor="let ans of quiz.answers"
      >
        <ngx-view-quiz-answer
          [submitted]="quiz.submitted"
          [ans]="ans"
          (onSelectedAns)="selectedAns($event)"
        >
        </ngx-view-quiz-answer>
      </div>
    </div>
  </nb-card-body>
  <nb-card-body *ngIf="quiz.type === 'input'">
    <h6>Nhập đáp án</h6>
    <div class="form-group">
      <input
        type="text"
        nbInput
        fullWidth
        fieldSize="giant"
        status="info"
        shape="semi-round"
        placeholder="Nhập đáp án"
        [(ngModel)]="quiz.inputAnswer"
        [disabled]="quiz.submitted"
      />
    </div>
    <h6 *ngIf="quiz.submitted && !quiz.isCorrect && quiz.valueAnswer">
      Đáp án đúng: <span class="text-danger"> {{ quiz.valueAnswer }}</span>
    </h6>
  </nb-card-body>

  <nb-card-footer>
    <nb-accordion
      *ngIf="quiz.submitted && quiz.explain"
      [nbSpinner]="loadingContentEditor"
      nbSpinnerStatus="info"
    >
      <nb-accordion-item>
        <nb-accordion-item-header> Xem hướng dẫn </nb-accordion-item-header>
        <nb-accordion-item-body>
          <ngx-view-document [content]="quiz.explain"> </ngx-view-document>
        </nb-accordion-item-body>
      </nb-accordion-item>
    </nb-accordion>

    <div class="button-actions">
      <ngx-view-like [quiz]="quiz"> </ngx-view-like>

      <ngx-button-report-spam [quiz]="quiz"></ngx-button-report-spam>
    </div>
  </nb-card-footer>
</nb-card>
